import React from "react";
import "./ProjectGallery.css";

// Array of image paths
const images = [
  "/images/Projects/proj1.webp",
  "/images/Projects/proj2.webp",
  "/images/Projects/proj3.webp",
  "/images/Projects/proj4.webp",
  "/images/Projects/proj5.webp",
  "/images/Projects/proj6.webp",
  // "/images/Projects/proj7.webp",
  "/images/Projects/proj8.webp",
  "/images/Projects/proj9.webp",
  "/images/Projects/proj10.webp",
  "/images/Projects/proj11.webp",
  "/images/Projects/proj12.webp",
  "/images/Projects/proj13.webp",
  "/images/Projects/proj14.webp",
  "/images/Projects/proj15.webp",
  "/images/Projects/proj16.webp",
  "/images/Projects/proj17.webp",
  "/images/Projects/proj18.webp",
  "/images/Projects/proj19.webp",
  "/images/Projects/proj20.webp",
  "/images/Projects/proj21.webp",
  "/images/Projects/proj22.webp",
  "/images/Projects/proj23.webp",
  "/images/Projects/proj24.webp",
  "/images/Projects/proj25.webp",
  "/images/Projects/proj26.webp",
  "/images/Projects/proj27.webp",
  "/images/Projects/proj28.webp",
  "/images/Projects/proj29.webp",
  "/images/Projects/proj30.webp",
  "/images/Projects/proj31.webp",
  "/images/Projects/proj32.webp",
  "/images/Projects/proj33.webp",
  "/images/Projects/proj34.webp",
  "/images/Projects/proj35.webp",
  "/images/Projects/proj36.webp",
  "/images/Projects/proj37.webp"
  // Add more image paths
];

const ProjectGallery = () => {
  return (
    <div className="project-gallery-container">
      <h2 className="gallery-title">Our Work</h2>
      <div className="gallery-grid">
        {images.map((src, idx) => (
          <div key={idx} className="gallery-item">
            <img src={src} alt={`project-${idx + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectGallery;
